// import "./App.css";
import SignUpPage from "@Pages/Signup2";
import SignInPage from "@Pages/Login";
// import SignUpConnect from "@Pages/ConnectInstagram";
import { BrowserRouter, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { ROUTES } from "@Constants/routes";
import IgConnected from "@Pages/IgConnected";
import Contacts from "@Pages/Contacts";
import { useLazyGetProfileQuery } from "@Pages/Profile/apiSlice";
import { useEffect } from "react";
import { ProtectedRoute } from "./ProtectedRoute";
import AutomationList from "@Pages/AutomationList";
import EditAutomation from "@Pages/EditAutomation";
import Error404 from "@Pages/Error404";
import Setting from "@Pages/Setting";
import UserDetails from "@Pages/UserDetails";
import Channels from "@Pages/Channels";
import ScheduledPostList from "@Pages/ScheduledPostList";
import Inbox from "@Pages/Inbox";
import AutomationBuilder from "@Pages/AutomationBuilder";
import EditScheduledPost from "@Pages/ScheduledPostEdit";
import InstagramLogin from "@Pages/InstagramLogin";
import Comments from "@Pages/Comments";
import PaymentOptions from "@Pages/PaymentOption";
import DashboardLayout from "./DashboardLayout";
import AutomationV0 from "@Pages/AutomationBuilderV0";
import RedirectPage from "@Pages/Redirect";
import ReferralPage from "@Pages/Referral";
import ForgetPassword from "@Pages/UpdatePassword";
import ResetLink from "@Pages/UpdatePassword/ResetLink";
import OtpVerification from "@Pages/OtpVerification";
import DashboardMetrics from "@Pages/Dashboard";
import posthog from "posthog-js";
import IGSelect from "@Pages/IGSelect";


// 👇 Simple PageView tracker (typed)
import { PropsWithChildren } from "react";
import { AnalyticsParamBuilder } from "@Utils/common";

const PageViewTracker: React.FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    posthog.capture("page_view", AnalyticsParamBuilder({
      kingdom: location.pathname,
    }));
  }, [location]);

  return <>{children}</>;
};



function Layout() {

  const [getProfile, { data: getProfileDataResponse }] = useLazyGetProfileQuery();

  useEffect(() => {
    getProfile({})

  }, [])

  useEffect(() => {
    if (getProfileDataResponse) {
      console.log(getProfileDataResponse);
    }
  }, [getProfileDataResponse])


  return (
    <BrowserRouter>
      <PageViewTracker>
        <Routes>
          {/* <Route path={ROUTES.SIGNUP_PAGE} element={<SignUpPage />}></Route> */}
          {/* <Route path={ROUTES.VERIFY_OTP_PAGE} element={<OtpVerification />}></Route> */}
          <Route path={ROUTES.LOGIN} element={<SignInPage />}></Route>
          <Route path={ROUTES.UPDATE_PASSWORD} element={<ForgetPassword />}></Route>
          <Route path={ROUTES.RESET_PASSWORD} element={<ResetLink />}></Route>
          <Route path={ROUTES.ALL} element={<Error404 />}></Route>
          <Route path={ROUTES.REDIRECT} element={<RedirectPage />}></Route>

          {/* Dashboard Layout and its children */}
          <Route path={ROUTES.DASHBOARD} element={<ProtectedRoute Component={DashboardLayout} />}>
            {/* <Route path={ROUTES.DASHBOARD} element={<ProtectedRoute Component={DashboardLayout} />}> */}
            <Route index element={<ProtectedRoute Component={DashboardMetrics} />} />
            <Route path="inbox" element={<Inbox />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="automations" element={<AutomationList />} />
            {/* <Route path="schedule" element={<ScheduledPostList />} />
            <Route path="comments" element={<Comments />} /> */}
            <Route path="automations/:automationId" element={<ProtectedRoute Component={AutomationV0} />} />
            <Route path="settings" element={<ProtectedRoute Component={Setting} />}></Route>
            <Route path={"settings/user"} element={<ProtectedRoute Component={UserDetails} />}></Route>
            <Route path={"settings/channel"} element={<ProtectedRoute Component={Channels} />}></Route>
            {/* <Route path={"comments"} element={<ProtectedRoute Component={Comments} />}></Route> */}
            <Route path={"referral"} element={<ProtectedRoute Component={ReferralPage} />}></Route>

          </Route>

          {/* Other Protected Routes */}
          {/* <Route
            path={ROUTES.SIGNUP_CONNECT_PAGE}
            element={<ProtectedRoute Component={SignUpConnect} />}
          ></Route> */}
          <Route
            path={ROUTES.IG_CONNECT_SUCCESS}
            element={<ProtectedRoute Component={IgConnected} />}
          ></Route>
          {/* <Route path={ROUTES.PAYMENTPAGE} element={<ProtectedRoute Component={PaymentOptions} />}></Route> */}
          {/* <Route path={ROUTES.INBOX} element={<ProtectedRoute Component={Inbox} />}></Route>
          <Route path={ROUTES.CONTACTS} element={<ProtectedRoute Component={Contacts} />}></Route> */}
          {/* <Route path={ROUTES.CONNECT_FACEBOOK} element={<ProtectedRoute Component={ConnectFacebook} />}></Route> */}
          {/* <Route path={ROUTES.AUTOMATIONS} element={<ProtectedRoute Component={AutomationList} />}></Route> */}
          {/* <Route path={ROUTES.EDIT_AUTOMATIONS} element={<ProtectedRoute Component={EditAutomation} />}></Route> */}

          {/* <Route path={ROUTES.SCHEDULED_POST} element={<ProtectedRoute Component={ScheduledPostList} />}></Route> */}
          {/* <Route path={"/automations/:automation_doc_id"} element={<ProtectedRoute Component={AutomationBuilder}/>}></Route> */}
          {/* <Route path={ROUTES.EDIT_SCHEDULED_POST} element={<ProtectedRoute Component={EditScheduledPost} />}></Route> */}

          <Route path={ROUTES.IG_CONNECT} element={<ProtectedRoute Component={InstagramLogin} />}></Route>
          {/* <Route path={ROUTES.COMMENTS} element={<ProtectedRoute Component={Comments} />}></Route> */}
          {/* Top-level accounts selection page */}
          <Route path={ROUTES.IG_SELECT} element={<ProtectedRoute Component={IGSelect} />}></Route>

          <Route path={ROUTES.BLANK} element={<Navigate to={ROUTES.DASHBOARD} replace />}></Route>
        </Routes>
      </PageViewTracker>
    </BrowserRouter>
  );
}

export default Layout;
